import React from 'react';

import { CLIENT_FORM } from 'src/constants/FormNames';
import { PlusSquare } from 'jbc-front/components/icons';
import BranchItemSection from './BranchItemSection';
import { useTranslation } from 'react-i18next';

const MAX_CLIENT_BRANCH = 6;

const BranchSection = props => {
  const { isNewForm, fields } = props;
  const { t } = useTranslation();
  return (
    <div>
      {fields.map((branch, index) => (
        <BranchItemSection
          key={branch}
          keyIndex={index + 1}
          index={index}
          isNewForm={isNewForm}
          formKey={branch}
          formName={CLIENT_FORM}
          removable={!fields.get(index).hasEmployeeClientBranches}
          remove={() => fields.remove(index)}
        />
      ))}

      {fields.length < MAX_CLIENT_BRANCH && (
        <div className="u-ta-r">
          <div role="button" tabIndex="0" onClick={() => fields.push({ isDependentBranch: true })} className="u-txt-addinfo">
            <PlusSquare size={20} className="u-txt-addinfo-icon" />{t('features.Clients.components.BranchSection.add_new_branch')}
          </div>
        </div>
      )}
    </div>
  );
};
export default BranchSection;